module.exports = __webpack_public_path__ + "static/media/Press_Mobile.7cf90f12.svg";